module.exports=function(scope){ return `<!-- enrollmentIdentifier found in database -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The entry in the database for this enrollmentIdentifier was successfully deleted."
    },
    "data": null
}

<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "No entry found in the database for this enrollmentIdentifier."
    },
    "data": null
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/enrollment-delete.json.tpl